import { Injectable, inject } from "@angular/core";
import { OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { HelpersService } from "../helpers-service/helpers.service";
import { AuthService } from "../auth";
import { ResponseErrorHandlerService } from "../response-error-handler-service/response-error-handler.service";

@Injectable()
export class MicroServiceError implements OnDestroy {
    private helpersService = inject(HelpersService);
    private authService = inject(AuthService);
    private responseErrorHandler = inject(ResponseErrorHandlerService);

    microServiceErrorSubscription: Subscription;
    showBannerSubscription: Subscription;
    hideBannerSubscription: Subscription;
    userLogoutSubscription: Subscription;
    signalRBanner = false;
    generalErrorBanner = false;
    lostConnection = false;
    signalRTimer;
    private lostConnectionTimer;

    constructor() {
        this.microServiceErrorSubscription = this.helpersService.microServiceErrorEvent$.subscribe((data) => {
            if (typeof data === "object" && data.isOnline === true) {
                this.lostConnection = false;
            } else {
                this.generalErrorBanner = true;
            }
            this.showHideToastPopup();
        });
        this.userLogoutSubscription = this.authService.userLogoutEvent$.subscribe((event) => {
            this.signalRBanner = false;
            this.generalErrorBanner = false;
            this.lostConnection = false;
            this.showHideToastPopup();
        });
        this.showBannerSubscription = this.responseErrorHandler.showBannerEvent$.subscribe((data) => {
            if (this.authService.loggedIn()) {
                if (data.type === "signalR") {
                    this.signalRTimer = setTimeout(() => {
                        this.signalRBanner = true;
                        this.showHideToastPopup();
                        clearTimeout(this.signalRTimer);
                        this.signalRTimer = null;
                    }, 5000);
                }
                if (data.type === "microService") {
                    this.generalErrorBanner = true;
                    this.showHideToastPopup();
                }
                if (data.type === "lostConnection") {
                    this.lostConnectionTimer = setTimeout(() => {
                        if (!this.helpersService.isOnline) {
                            this.lostConnection = true;
                        } else {
                            this.generalErrorBanner = true;
                        }
                        this.showHideToastPopup();
                    }, 0);
                }
            }
        });
        this.hideBannerSubscription = this.responseErrorHandler.hideBannerEvent$.subscribe((data) => {
            if (this.authService.loggedIn()) {
                if (data.type === "signalR") {
                    this.signalRBanner = false;
                    this.responseErrorHandler.hidePopup("SignalRErrorDisconnect");
                    if (this.signalRTimer) {
                        clearTimeout(this.signalRTimer);
                        this.signalRTimer = null;
                    }
                }
                if (data.type === "microService") {
                    this.generalErrorBanner = false;
                    this.responseErrorHandler.hidePopup("microserviceGeneralError");
                }
                if (data.type === "lostConnection") {
                    this.lostConnection = false;
                    this.responseErrorHandler.hidePopup("ErrorConnexionLost");
                }
            }
        });
    }

    ngOnDestroy() {
        this.microServiceErrorSubscription.unsubscribe();
        this.showBannerSubscription.unsubscribe();
        this.hideBannerSubscription?.unsubscribe();
        this.userLogoutSubscription.unsubscribe();
        if (this.signalRTimer) clearTimeout(this.signalRTimer);
        if (this.lostConnectionTimer) clearTimeout(this.lostConnectionTimer);
    }

    dismissGeneralError() {
        this.generalErrorBanner = false;
        this.responseErrorHandler.hideBannerEmitter.next({ type: "microService" });
    }
    showHideToastPopup() {
        if (this.generalErrorBanner && !this.lostConnection) {
            this.responseErrorHandler.showPopup({
                typeLayout: "ERROR",
                messageCode: "microserviceGeneralError",
            });
        }

        if (this.signalRBanner && !this.lostConnection) {
            this.responseErrorHandler.showPopup({
                typeLayout: "ALERT",
                messageCode: "SignalRErrorDisconnect",
            });
        }
        if (this.lostConnection) {
            this.responseErrorHandler.showPopup({
                typeLayout: "ERROR",
                messageCode: "ErrorConnexionLost",
            });
        }
    }
}
